// extracted by mini-css-extract-plugin
module.exports = {"routing":"routing__1k2kZ"};